module.exports = __webpack_public_path__ + "img/renacimiento-unido.a2375e3a.png";